<div class="grid">
  <app-copiable-info label="OCell plug ID" icon="outlet" [value]="chargepoint?.plugId ?? 'Unknown'"></app-copiable-info>
  <app-copiable-info label="Ivy status" icon="info" [value]="chargepoint?.specificStatus ?? 'Unknown'"></app-copiable-info>
</div>
